<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Estacionamento de Tampas, Grades e Paletes</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Nova Entrada"
          icon="assets/add.svg"
          (click)="navigateNovaEntrada()"></app-botao>
        <app-botao
          type="primario"
          class="button"
          text="Nova Saída"
          icon="assets/add.svg"
          (click)="navigateNovaSaida()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem</div>
        <div class="align-button">
          <form
            [formGroup]="form"
            (ngModelChange)="getPaletes()"
            class="table-filters">
            <app-input
              label="Agendamento"
              placeholder="Digite aqui"
              name="FK_AGND"
              formControlName="FK_AGND"
              width="100%"></app-input>
            <app-input
              label="ID Empresa"
              placeholder="Digite aqui"
              name="FK_EPSA"
              formControlName="FK_EPSA"
              width="100%"></app-input>
            <app-input
              label="Motorista"
              placeholder="Digite aqui"
              name="NM_MTRT"
              formControlName="NM_MTRT"
              width="100%"></app-input>
            <app-input
              label="Placa da Carreta"
              placeholder="Digite aqui"
              name="TX_PLCA_CRRT"
              formControlName="TX_PLCA_CRRT"
              width="100%"></app-input>
            <span></span>
            <span></span>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"></app-input>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <form
      [formGroup]="form"
      (ngModelChange)="getPaletes()"
      class="table-filters">
      <app-input
        label="N° do Agendamento"
        placeholder="Digite aqui"
        name="FK_AGND"
        formControlName="FK_AGND"
        width="100%"></app-input>
      <app-input
        label="ID Empresa"
        placeholder="Digite aqui"
        name="FK_EPSA"
        formControlName="FK_EPSA"
        width="100%"></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite aqui"
        name="NM_MTRT"
        formControlName="NM_MTRT"
        width="100%"></app-input>
      <app-input
        label="Placa da Carreta"
        placeholder="Digite aqui"
        name="TX_PLCA_CRRT"
        formControlName="TX_PLCA_CRRT"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
